<template>
  <v-form v-model="valid" ref="DialogForm">
    <slotted-dialog :externaltrigger="dialogtrigger" :externalCloseTrigger="closetrigger">

      <template v-slot:header>
        <v-card :color="editObject.OrderType == 1 ? 'disabled darken-3' : 'primary'" class="rounded-0" dark flat>
          <v-container>
            <v-row justify="space-between" align="center">
              <v-spacer></v-spacer>
              <v-col cols="auto" class="d-flex align-center pb-0">
                <DatePicker v-model="editObject.EmploymentTimeReportDate" type="date" align="right" :format="dateformat"
                  start-placeholder="Date" size="small" :picker-options="{ firstDayOfWeek: 1 }" :clearable="false"
                  class="headerTimeSelect ml-3" style="width: 150px !important; font-size: 16px;">
                </DatePicker>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
            <v-row justify="space-between" align="center">
              <v-col cols="auto" class="d-flex flex-column align-center">
                <h4 v-text="$t('servicesystem.common_objects.commonterms.start')" />
                <TimeSelect v-model="startTime" :format="timefomat" :picker-options="{
                  start: '00:00',
                  end: '23:45',
                  step: '00:15'
                }" placeholder="00:00" prefix-icon=" " class="headerTimeSelect">
                </TimeSelect>
              </v-col>
              <v-col cols="auto" class="d-flex flex-column align-center">
                <h2 v-text="$t('servicesystem.common_objects.commonterms.duration')" />
                <TimeSelect v-model="duration" :format="timefomat" :picker-options="{
                  start: '00:00',
                  end: '24:00',
                  step: '00:15'
                }" prefix-icon=" " class="headerTimeSelect" :clearable="false"
                  style="width: 138px !important; font-size: 30px;">
                </TimeSelect>
              </v-col>
              <v-col cols="auto" class="d-flex flex-column align-center">
                <h4 v-text="$t('servicesystem.common_objects.commonterms.end')" />
                <TimeSelect v-model="stopTime" :format="timefomat" :picker-options="{
                  start: '00:00',
                  end: '23:45',
                  step: '00:15',
                  minTime: startTime
                }" placeholder="00:00" prefix-icon=" " class="headerTimeSelect">
                </TimeSelect>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </template>

      <template v-slot:content>
        <v-container :key="dialogtrigger" class="pa-0">
          <AutoArticleDescription :detail="{ ...editObject, Type: 1 }" :loading="loading" :readonly="false"
            ref="autodesc" @change="val => editObject.ArticleDescription = val">
          </AutoArticleDescription>

          <v-row align="stretch" class="px-3 mt-0">
            <v-col>
              <div class="d-flex flex-column">
                <small class="mb-1 mt-1">{{ $t('servicesystem.common_objects.time_report.type') }}</small>
                <QButtonGroup v-model="editObject.OrderType" :list="activityTypeOptions" :edit="true" dense noempty
                  class="mb-3">
                </QButtonGroup>
              </div>
              <QAutoComplete v-if="editObject.OrderType != 1" v-model="editObject.ArticleNumber"
                :list="availableArticles" :label="$t('servicesystem.common_objects.time_report.work_type')"
                :textkey="'ArticleDescription'" :valuekey="'ArticleNumber'" externaledit class="mb-3"
                :rules="[requiredRule]">
              </QAutoComplete>
              <QTextField v-else :value="$t('servicesystem.common_objects.time_report.internal_work')"
                :label="$t('servicesystem.common_objects.time_report.work_type')" disabled :rules="[requiredRule]">
              </QTextField>
              <QAutoComplete v-model="editObject.EmploymentId"
                :label="$t('servicesystem.common_objects.order.employee')" :list="employmentList" :textkey="'Name'"
                :valuekey="'Id'" externaledit class="mb-3" :rules="[requiredRule]">
              </QAutoComplete>
            </v-col>
            <v-col v-if="editObject.OrderType == 0" class="d-flex flex-column justify-end">
              <div class="d-flex align-end">
                <JobSelect v-model="editObject.ParentJob" :label="$t('servicesystem.common_objects.order.order')"
                  class="mb-3" externaledit hideIcon returnobject @input="handleParentJobChange">
                </JobSelect>
                <v-card v-if="!editObject.ReadOnly && editObject.JobStatusId > 69" class="d-flex pa-1 mb-3 ml-2"
                  outlined style="height: fit-content;">
                  <v-icon color="warning" size="18">mdi-alert</v-icon>
                  <v-icon color="warning" size="18">mdi-lock</v-icon>
                </v-card>
              </div>
              <div>
                <QAutoComplete v-model="editObject.OrderId" :key="editObject.ParentJobId"
                  :label="$t('servicesystem.common_objects.time_report.machine_on_order')" :list="machineJobOptions"
                  :textkey="'DisplayName'" :valuekey="'OrderId'" externaledit class="mb-3" :rules="[requiredRule]">
                </QAutoComplete>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:buttons>
        <v-btn v-if="editObject.OrderType == 0 && !orderIsLocked && editObject.Id" color="error" outlined
          v-text="$t('servicesystem.common_objects.commonterms.delete')" :loading="deleteLoading"
          @click="!anyLoading ? deleteRow() : null">
        </v-btn>
        <v-spacer></v-spacer>

        <v-btn text color="primary" v-text="$t('servicesystem.common_objects.commonterms.cancel')"
          @click="closetrigger++">
        </v-btn>
        <v-btn :disabled="editObject.OrderType != 0 || orderIsLocked || !valid || deleteLoading"
          :color="editObject.OrderType == 0 && !orderIsLocked && valid && !deleteLoading ? 'primary' : 'disabled'"
          :loading="loading" :dark="!orderIsLocked && valid && !deleteLoading"
          @click="valid && !anyLoading ? save() : null">
          {{ $t('servicesystem.common_objects.commonterms.save') }}
        </v-btn>
      </template>
    </slotted-dialog>
  </v-form>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import {
  DatePicker,
  TimeSelect,
  //InputNumber
} from 'element-ui';
import JobSelect from "@/components/Inputs/EntityDropdowns/JobSelect2.vue";
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";
import moment from "moment";
import Vue from "vue";
import AutoArticleDescription from "@/views/job/viewjob/parts/AutoArticleDescription.vue";

export default {
  name: "EditTimeRowDialog",
  props: {
    externaltrigger: Number,
    employmentList: Array,
    articles: Array,
    item: Object,
  },
  components: {
    SlottedDialog,
    DatePicker,
    //InputNumber,
    TimeSelect,
    JobSelect,
    AutoArticleDescription,
  },
  mixins: [clientAPI],

  data() {
    return {
      dialogtrigger: 0,
      closetrigger: 0,
      valid: false,
      loading: false,
      deleteLoading: false,

      editObject: {},

      activityTypeOptions: [
        { value: 0, text: this.$t('servicesystem.common_objects.time_report.normal_activity') },
        { value: 1, text: this.$t('servicesystem.common_objects.time_report.internal_activity') },
      ],

      machineJobOptions: [],
    };
  },

  methods: {
    async save() {
      this.loading = true;
      const dto = Object.assign({}, this.editObject);
      var error = null;

      if (dto.Id) {
        await this.updateTimeReportRow(dto)
          .then((response) => {
            response.update = true;
            this.$emit("Update", response);
          })
          .catch(() => { error = true; });
      }
      else {
        await this.createTimeReportRow(dto)
          .then((response) => {
            response.new = true;
            this.$emit("Add", response);
          })
          .catch(() => { error = true; });
      }

      this.loading = false;
      if (!error) {
        this.closetrigger++;
      }
    },

    async deleteRow() {
      this.$store.dispatch('ConfirmDialog/Show').then(async confirmed => {
        if (confirmed) {
          // User confirmed
          this.deleteLoading = true;
          const dto = Object.assign({}, this.editObject);
          await this.deleteTimeReportRow(dto)
            .then(() => {
              this.$emit("Delete", this.editObject);
              this.closetrigger++;
            })
            .catch(() => { })
            .finally(() => {
              this.deleteLoading = false;
            });
        }
      });
    },

    handleParentJobChange(job) {
      if (job) {
        this.editObject.ParentJob = job;
        this.editObject.ParentJobId = job.Id;
        this.editObject.ParentOrderId = job.OrderId;
        this.editObject.CustomerId = job.CustomerId;
        this.editObject.CustomerName = job.CustomerName;

        this.machineJobOptions = job.Jobs.filter(x => x.JobStatusId < 110);
        var mj = this.machineJobOptions[0];
        //console.log('machineJobOptions', this.machineJobOptions, orderId);
        Vue.set(this.editObject, 'JobId', mj?.Id);
        Vue.set(this.editObject, 'JobStatusId', mj?.JobStatusId);
        Vue.set(this.editObject, 'OrderId', mj?.OrderId);
        Vue.set(this.editObject, 'MachineId', mj.MachineId);
      } else {
        this.editObject.ParentJob = null;
        this.editObject.ParentJobId = null;
        this.editObject.ParentOrderId = null;
        this.editObject.CustomerId = null;
        this.editObject.CustomerName = null;
        this.editObject.OrderId = null;
        this.editObject.JobStatusId = null;
        this.editObject.JobId = null;
        this.editObject.MachineId = null;

        this.machineJobOptions = [];
      }
      console.log('set pj', this.editObject, job);
    },

    parseItem() {
      if (this.item) {
        this.editObject = Object.assign({}, this.item);
        this.editObject.ParentJob = { Id: this.item.ParentJobId };
        this.machineJobOptions = [{ Id: this.item.JobId, OrderId: this.item.OrderId, DisplayName: this.item.JobDisplayName }];
      }
      else {
        this.editObject = {
          EmploymentId: this.userInfo?.EmploymentId?.trim(),
          ArticleNumber: this.articles?.[0]?.ArticleNumber,
          ArticleDescription: undefined,
          EmploymentTimeReportDate: new Date(),
          OrderId: null,
          ArticleCount: 1,
          Id: null,
        };
      }
      //console.log('set item', this.editObject, this.item);
      this.dialogTrigger++;
    },

    addZonedTimeStringToUtcDateTimeString(dateString, timeString) {
      let tempDate = moment(dateString);
      if (timeString) {
        tempDate.set({
          'hour': parseInt(timeString.split(':')[0]),
          'minute': parseInt(timeString.split(':')[1])
        });
      }
      else {
        tempDate.set({
          'hour': 0,
          'minute': 0
        });
      }
      return tempDate.utc().toISOString();
    },
  },

  computed: {
    anyLoading() {
      return this.loading || this.deleteLoading;
    },

    orderIsLocked() {
      return this.editObject.ReadOnly || this.editObject.JobStatusId > 69;
    },

    startTime: {
      get() {
        var val = this.i18nFormatTime(this.editObject.StartDateTime);
        return val;
      },
      set(value) {
        var string = this.addZonedTimeStringToUtcDateTimeString(this.editObject.StartDateTime, value);
        Vue.set(this.editObject, 'StartDateTime', string);
        // if start time is present adjust stop time and set article count
        if (this.editObject.ArticleCount) {
          const startTime = moment(this.editObject.StartDateTime);
          const endTime = startTime.clone().add(this.editObject.ArticleCount, 'hours');
          var string2 = endTime.utc().toISOString();
          Vue.set(this.editObject, 'StopDateTime', string2);
        }
      },
    },

    duration: {
      get() {
        //return articleCount double as time string
        const hours = Math.floor(this.editObject.ArticleCount).toString().padStart(2, '0');
        const minutes = Math.round((this.editObject.ArticleCount - Math.floor(this.editObject.ArticleCount)) * 60).toString().padStart(2, '0');
        return `${hours}:${minutes}`;
      },
      set(value) {
        if (!value) {
          this.editObject.ArticleCount = 0;
        }
        else {
          // Split and convert the duration
          const [hours, minutes] = value.split(':').map(Number);
          var doubleHours = hours + minutes / 60;
          Vue.set(this.editObject, 'ArticleCount', doubleHours);

          // if start time is present adjust stop time and set article count
          if (this.editObject.StartDateTime) {
            const startTime = moment(this.editObject.StartDateTime);
            const endTime = startTime.clone().add(hours, 'hours').add(minutes, 'minutes');
            var string = endTime.utc().toISOString();
            Vue.set(this.editObject, 'StopDateTime', string);
          }
        }
      },
    },

    stopTime: {
      get() {
        var val = this.i18nFormatTime(this.editObject.StopDateTime);
        return val;
      },
      set(value) {
        var string = this.addZonedTimeStringToUtcDateTimeString(this.editObject.StopDateTime, value);
        const startTime = moment(this.editObject.StartDateTime);
        const endTime = moment(string);
        const duration = moment.duration(endTime.diff(startTime));
        this.editObject.ArticleCount = duration.asHours();

        Vue.set(this.editObject, 'StopDateTime', string);
      },
    },

    availableArticles() {
      return this.articles;
    },

    dateformat() {
      return this.$t('servicesystem.formatting.dateformat').replace('YYYY', 'yyyy').replace('DD', 'dd');
    },
    timefomat() {
      return this.$t('servicesystem.formatting.timeformat');
    },
  },

  watch: {
    externaltrigger: function () {
      this.parseItem();
      this.dialogtrigger++;
    },
  },
};
</script>

<style lang="scss">
.headerTimeSelect {
  width: 120px !important;
  font-size: 22px;
}

.headerTimeSelect input {
  color: white;
  background: none !important;
  border: none !important;
}
</style>